(function(){
'use strict';
var K={tab:'zingiez:tablets',fl:'zingiez:flavor',nm:'zingiez:name',fb:'zingiez:feedbackAnswer',ord:'zingiez:hasOrdered'};
var get=function(k,d){try{return localStorage.getItem(k)||d}catch(e){return d}};
var set=function(k,v){try{localStorage.setItem(k,v)}catch(e){}};
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var esc=function(s){return String(s).replace(/[<>&"]/g,'')};

/* ---------- feedback for a code ---------- */
(function(){
  var host=$('[data-welcome]');if(!host)return;
  var name=get(K.nm,''),ordered=get(K.ord,'')==='1',answered=get(K.fb,'');
  if(!name||!ordered)return;
  var tab=get(K.tab,''),fl=get(K.fl,'cherry berry');
  function reward(msg){
    host.style.background='var(--yel)';host.style.color='var(--ink)';
    host.innerHTML='<div class="wrap" style="display:flex;gap:16px;align-items:center;justify-content:space-between;flex-wrap:wrap">'+
      '<div><div class="lab" style="font-size:10px;opacity:.65;margin-bottom:4px">your code</div>'+
      '<div style="font-family:Tosh;font-weight:900;font-size:22px">thanks, '+esc(name)+'. 15% off your next tin.</div>'+
      (msg?'<div style="font-size:13px;opacity:.75;margin-top:4px">'+msg+'</div>':'')+'</div>'+
      '<div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap">'+
      '<span class="lab" style="border:2px dashed var(--ink);border-radius:999px;padding:9px 18px;font-size:13px">FREQ15</span>'+
      '<a class="btn" style="padding:11px 22px;font-size:14px" href="/collections/all">use it</a></div></div>';
  }
  if(answered){reward(''); host.style.display='block'; return}
  host.style.background='var(--forest)';host.style.color='#fff';
  host.innerHTML='<div class="wrap" style="display:flex;gap:16px;align-items:center;justify-content:space-between;flex-wrap:wrap">'+
    '<div><div class="lab" style="font-size:10px;opacity:.6;margin-bottom:4px">two taps, 15% off</div>'+
    '<div style="font-family:Tosh;font-weight:900;font-size:22px">'+esc(name)+', how did the '+esc(fl)+' treat you?</div>'+
    (tab?'<div style="font-size:13px;opacity:.75;margin-top:4px">you landed on '+esc(tab)+' tablets last time.</div>':'')+'</div>'+
    '<div style="display:flex;gap:8px;flex-wrap:wrap">'+
    '<button data-fb="less" class="btn btn-o" style="padding:10px 18px;font-size:13px;border-color:rgba(255,255,255,.5);color:#fff">needed less</button>'+
    '<button data-fb="right" class="btn btn-y" style="padding:10px 18px;font-size:13px">that was the number</button>'+
    '<button data-fb="more" class="btn btn-o" style="padding:10px 18px;font-size:13px;border-color:rgba(255,255,255,.5);color:#fff">needed more</button>'+
    '<button data-fb="skip" style="background:none;border:none;color:#fff;opacity:.6;font-size:13px;cursor:pointer">later</button></div></div>';
  host.style.display='block';
  $$('[data-fb]',host).forEach(function(b){b.addEventListener('click',function(){
    var v=b.getAttribute('data-fb');
    if(v==='skip'){host.style.display='none';return}
    set(K.fb,v);
    reward(v==='less'?'noted: next time start lower.':v==='more'?'noted: next time start higher.':'noted: that\u2019s your number.');
  })});
})();

/* ---------- frequency finder ---------- */
(function(){
  var wrapEl=$('#ffmsgs');if(!wrapEl)return;
  var chips=$('#ffchips'),form=$('#ffform'),input=$('#ffinput');
  var numEl=$('#ffnum'),mgEl=$('#ffmg'),noteEl=$('#ffnote'),ctaEl=$('#ffcta'),kickEl=$('#ffkicker');
  var name=get(K.nm,''),lastTab=get(K.tab,'');
  var state={step:0,dose:null,occasion:'',tolerance:''};
  function bubble(text,who){
    var row=document.createElement('div');
    row.style.cssText='display:flex;justify-content:'+(who==='you'?'flex-end':'flex-start');
    var b=document.createElement('div');
    b.style.cssText='max-width:56ch;border-radius:22px;padding:13px 18px;font-size:15px;line-height:1.55;white-space:pre-wrap;'+
      (who==='you'?'background:var(--yel);color:var(--ink);border-bottom-right-radius:6px':'background:var(--paper);color:var(--ink);border-bottom-left-radius:6px');
    b.textContent=text;row.appendChild(b);wrapEl.appendChild(row);wrapEl.scrollTop=wrapEl.scrollHeight;
  }
  function setChips(list){
    chips.innerHTML='';
    list.forEach(function(c){
      var b=document.createElement('button');
      b.type='button';b.textContent=c;
      b.style.cssText='border:1.5px solid var(--hair);background:#fff;color:var(--ink);border-radius:999px;padding:9px 16px;font-family:Tosh;font-size:13px;cursor:pointer';
      b.addEventListener('click',function(){answer(c)});
      chips.appendChild(b);
    });
  }
  function setDose(n,note){
    state.dose=n;
    numEl.textContent=n;mgEl.textContent=n*5;
    noteEl.textContent=note;
    kickEl.textContent='your number';
    ctaEl.style.display='inline-block';
    ctaEl.textContent='set '+n+' on the dial \u2192';
    set(K.tab,String(n));
  }
  var STOP=/\b(pregnan|nursing|breastfeed|under 18|17|16|15|14|13|12|child|kid|heart condition|sensitive to caffeine)\b/i;
  function answer(text){
    bubble(text,'you');
    if(STOP.test(text)){
      bubble('i can\u2019t recommend a dose for that. zingiez isn\u2019t for children, pregnant or nursing women, or anyone sensitive to caffeine. if you have a medical condition or take prescription medication, talk to a physician first.','ff');
      setChips([]);return;
    }
    var t=text.toLowerCase();
    if(state.step===0){
      state.occasion=t;state.step=1;
      bubble('got it. how much caffeine do you normally have in a day?','ff');
      setChips(['barely any','a cup or two','i live on it']);
      return;
    }
    if(state.step===1){
      state.tolerance=t;state.step=2;
      var base=5;
      if(/deadline|drive|set|workout|gym|long|all.?night|shift/.test(state.occasion))base=20;
      else if(/focus|work|study|block|meeting|afternoon/.test(state.occasion))base=10;
      else if(/wake|morning|slow|light|little/.test(state.occasion))base=5;
      if(/barely/.test(t))base=Math.max(3,Math.round(base*0.6));
      if(/live on it/.test(t))base=Math.min(30,Math.round(base*1.5));
      base=Math.max(1,Math.min(40,base));
      var mg=base*5;
      bubble('start at '+base+' tablets. that\u2019s '+mg+'mg of caffeine and '+base*10+'mg of l-theanine.\n\nif it isn\u2019t enough, add five and see. the daily ceiling is 40 tablets, or 200mg.','ff');
      setDose(base,'that\u2019s '+mg+'mg, '+(Math.round(base/40*100))+'% of the daily ceiling.');
      setChips(['which flavor?','why l-theanine?','start over']);
      return;
    }
    if(/flavor/.test(t)){
      bubble('two: cherry berry, which is tart and dark, and mint mix, which is cool and clean. same tablet, same 5mg, same ratio. pick the taste you\u2019d chew ten of.','ff');
      setChips(['why l-theanine?','start over']);return;
    }
    if(/theanine/.test(t)){
      bubble('every tablet carries 10mg of l-theanine, twice the caffeine. it\u2019s there to prevent the crash, so the landing matches the lift.','ff');
      setChips(['which flavor?','start over']);return;
    }
    if(/start over|restart|again/.test(t)){
      state={step:0,dose:null,occasion:'',tolerance:''};
      wrapEl.innerHTML='';greet();return;
    }
    bubble('i only know what\u2019s on the label: 5mg of caffeine and 10mg of l-theanine a tablet, 100 in a tin, 40 tablets max a day. ask me about a moment and i\u2019ll give you a number.','ff');
    setChips(['a two-hour focus block','the 4pm slump','a long drive']);
  }
  function greet(){
    bubble((name?'hey '+name+'. ':'')+'tell me the moment and i\u2019ll give you a number.'+(lastTab?' last time you landed on '+lastTab+' tablets.':''),'ff');
    setChips(['a two-hour focus block','the 4pm slump','a long drive','before a workout']);
  }
  form.addEventListener('submit',function(e){e.preventDefault();var v=input.value.trim();if(!v)return;input.value='';answer(v)});
  greet();
})();
})();